<template>
  <div class="teacher-card" @click="openDetail">
    <div class="teacher-photo">
      <img :src="
        teacherData.teacher_avatar_url ||
        require('@/assets/images/common/teacher_icon.png')
      " alt="">
    </div>
    <div class="name text-overflow">{{ teacherData.teacher_name }}</div>
    <div
     class="teacher-info text-overflow"
     :title="teacherData.organ_name && teacherData.title ? teacherData.organ_name + ' ' + teacherData.title : teacherData.organ_name || teacherData.title"
    >
      <span>{{ teacherData.organ_name }}</span>
      <span v-if="teacherData.title">&emsp;{{ teacherData.title }}</span>
    </div>
    <!-- <div class="split"></div> -->
    <div class="intro text-overflow-two" v-html="$utils.getContentText(teacherData.introduction)"></div>
  </div>
</template>
<script>
export default {
  props: {
    teacherData: {
      required: true,
      defalut: {},
      type: Object,
    },
    menu: Object
  },
  methods: {
    openDetail() {
      window.open(
        `/teacherDetailInfo.html?id=${this.teacherData.teacher_id || this.teacherData.id}&usercode=${this.teacherData.usercode}&name=${this.menu.menu_name}&menuId=${this.menu.id}`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
// @import "~assets/index";
.teacher-card {
  position: relative;
  margin-top: 70px;
  width: 386px;
  height: 207px;
  padding: 0 15px 15px;
  background: #fff;
  border-radius: 4px;
  margin-right: 20px;
  cursor: pointer;
  border: 1px solid #ddd;
  &:hover {
    border-color: $--color-primary;
    box-shadow: 0 4px 4px 0px rgba($color: #000000, $alpha: 0.1);
  }
  &:nth-child(3n) {
    margin-right: 0;
  }
  .teacher-photo {
    position: absolute;
    top: -50px;
    left: 143px;
    border-radius: 50%;
    border: 1px solid #ddd;
    img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
  .name {
    padding-top: 68px;
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #333333;
    line-height: 21px;
  }
  .teacher-info {
    margin-top: 6px;
    height: 17px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: $--color-primary;
    line-height: 17px;
  }
  .split {
    margin: 8px auto 0;
    width: 20px;
    border-top: 1px solid #ddd;
  }
  .intro {
    margin: 24px auto 0;
    width: 305px;
    height: 40px;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #999;
    line-height: 20px;
  }
}
</style>